global.conmed = global.conmed || {};

conmed.dataFilter = function ($) {
    'use strict';

    var that = {
        selectors: {
            //dataList = '.data-selector'
        }
    };

    that.init = function () {

        // Dynamically attach change handlers to all filter dropdowns
        $('.filter.form-select').on('change', function (e) {
            FilterData();
        });

        function FilterData() {
            var pathname = window.location.pathname;
            var origin = window.location.origin;
            var filterParams = [];

            // Collect all filter dropdown values dynamically
            $('.filter.form-select').each(function() {
                var filterId = $(this).attr('id');
                var selectedValue = $(this).children("option:selected").val();

                if (selectedValue !== "" && selectedValue !== undefined) {
                    filterParams.push(filterId + '=' + selectedValue);
                }
            });

            // Build query string
            var filter = filterParams.length > 0 ? '?' + filterParams.join('&') : '';

            // Redirect with filters
            window.location = origin + pathname + filter;
        }



        function getUrlVars() {
            var vars = [], hash;

            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

            if (hashes === undefined) {
                return null;
            }

            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
        }

        function getQueryVariable(url, variable) {

            if (url.contains('?')) {
                var query = url.split('?')[1];
                var vars = query.split('&');
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split('=');
                    if (pair[0] == variable) {
                        return pair[1];
                    }
                }
            }

            return false;
        }

        document.addEventListener('click', function (e) {
            // Check if click is on accordion button or inside accordion content
            const clickedAccordionButton = e.target.closest('.accordion-button');
            const clickedAccordionContent = e.target.closest('.accordion-collapse');

            // Only proceed if click was outside accordion interactive areas
            if (!clickedAccordionButton && !clickedAccordionContent) {
                // Find all expanded accordions
                const openAccordions = document.querySelectorAll('.accordion-collapse.show');

                openAccordions.forEach(function (accordion) {
                    // Get the associated button
                    const accordionId = accordion.id;
                    const button = document.querySelector('[data-bs-target="#' + accordionId + '"]');

                    // Trigger a click on the button to properly close it
                    if (button && !button.classList.contains('collapsed')) {
                        button.click();
                    }
                });
            }
        });

        function equalizeCardHeights() {
            const rows = document.querySelectorAll('.documents-row');

            rows.forEach(row => {
                const cards = Array.from(row.querySelectorAll('.card-body'));

                // Reset heights first
                cards.forEach(card => card.style.height = 'auto');

                // Group cards by their top position (same row)
                const cardsByRow = {};
                cards.forEach(card => {
                    const topPos = card.getBoundingClientRect().top;
                    if (!cardsByRow[topPos]) {
                        cardsByRow[topPos] = [];
                    }
                    cardsByRow[topPos].push(card);
                });

                // Equalize height within each actual row
                Object.values(cardsByRow).forEach(rowCards => {
                    let maxHeight = 0;

                    // Find max height in this row
                    rowCards.forEach(card => {
                        maxHeight = Math.max(maxHeight, card.offsetHeight);
                    });

                    // Set all cards in this row to max height
                    rowCards.forEach(card => {
                        card.style.height = maxHeight + 'px';
                    });
                });
            });
        }

        // Run on load and resize
        window.addEventListener('load', equalizeCardHeights);
        window.addEventListener('resize', equalizeCardHeights);
       
    };

    return that;
}(jQuery);